export default {
  namespaced: true,
  state: {
    payload: {},
  },
  mutations: {
    SET_STATE(state, payload) {
      const { name, data } = payload;
      state.payload[name] = data;
    },
  },
  actions: {
    setState({ commit }, payload) {
      commit("SET_STATE", payload);
    },
  },
};
